module.exports = __webpack_public_path__ + "assets/images/seatingarrangement-02.b63f6a236222d2a11c0c28055800694a.svg";